export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-CH', {
    style: 'currency',
    currency: 'CHF',
  }).format(amount);
};
